export default "__VITE_ASSET__D3$lPIHU__"